/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AnnouncementsRouteImport } from './routes/announcements'
import { Route as ApiDocsRouteImport } from './routes/api-docs'
import { Route as AppAuthRouteImport } from './routes/app-auth'
import { Route as ArchiveRouteImport } from './routes/archive'
import { Route as BoardRouteImport } from './routes/board'
import { Route as JukeboxRouteImport } from './routes/jukebox'
import { Route as SearchRouteImport } from './routes/search'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as AnnouncementsIndexRouteImport } from './routes/announcements.index'
import { Route as AnnouncementsAnnouncementIdRouteImport } from './routes/announcements.$announcementId'
import { Route as HistoryModeRouteImport } from './routes/history.$mode'
import { Route as SpaceThreadIdRouteImport } from './routes/space.$threadId'
import { Route as ThreadThreadIdRouteImport } from './routes/thread.$threadId'
import { Route as SlugThreadThreadIdRouteImport } from './routes/$slug.thread.$threadId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AnnouncementsRoute = AnnouncementsRouteImport.update({
  id: '/announcements',
  path: '/announcements',
  getParentRoute: () => rootRouteImport,
} as any)
const ApiDocsRoute = ApiDocsRouteImport.update({
  id: '/api-docs',
  path: '/api-docs',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAuthRoute = AppAuthRouteImport.update({
  id: '/app-auth',
  path: '/app-auth',
  getParentRoute: () => rootRouteImport,
} as any)
const ArchiveRoute = ArchiveRouteImport.update({
  id: '/archive',
  path: '/archive',
  getParentRoute: () => rootRouteImport,
} as any)
const BoardRoute = BoardRouteImport.update({
  id: '/board',
  path: '/board',
  getParentRoute: () => rootRouteImport,
} as any)
const JukeboxRoute = JukeboxRouteImport.update({
  id: '/jukebox',
  path: '/jukebox',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const AnnouncementsIndexRoute = AnnouncementsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AnnouncementsRoute,
} as any)
const AnnouncementsAnnouncementIdRoute =
  AnnouncementsAnnouncementIdRouteImport.update({
    id: '/$announcementId',
    path: '/$announcementId',
    getParentRoute: () => AnnouncementsRoute,
  } as any)
const HistoryModeRoute = HistoryModeRouteImport.update({
  id: '/history/$mode',
  path: '/history/$mode',
  getParentRoute: () => rootRouteImport,
} as any)
const SpaceThreadIdRoute = SpaceThreadIdRouteImport.update({
  id: '/space/$threadId',
  path: '/space/$threadId',
  getParentRoute: () => rootRouteImport,
} as any)
const ThreadThreadIdRoute = ThreadThreadIdRouteImport.update({
  id: '/thread/$threadId',
  path: '/thread/$threadId',
  getParentRoute: () => rootRouteImport,
} as any)
const SlugThreadThreadIdRoute = SlugThreadThreadIdRouteImport.update({
  id: '/$slug/thread/$threadId',
  path: '/$slug/thread/$threadId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/announcements': typeof AnnouncementsRouteWithChildren
  '/api-docs': typeof ApiDocsRoute
  '/app-auth': typeof AppAuthRoute
  '/archive': typeof ArchiveRoute
  '/board': typeof BoardRoute
  '/jukebox': typeof JukeboxRoute
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRoute
  '/announcements/$announcementId': typeof AnnouncementsAnnouncementIdRoute
  '/history/$mode': typeof HistoryModeRoute
  '/space/$threadId': typeof SpaceThreadIdRoute
  '/thread/$threadId': typeof ThreadThreadIdRoute
  '/announcements/': typeof AnnouncementsIndexRoute
  '/$slug/thread/$threadId': typeof SlugThreadThreadIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/api-docs': typeof ApiDocsRoute
  '/app-auth': typeof AppAuthRoute
  '/archive': typeof ArchiveRoute
  '/board': typeof BoardRoute
  '/jukebox': typeof JukeboxRoute
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRoute
  '/announcements/$announcementId': typeof AnnouncementsAnnouncementIdRoute
  '/history/$mode': typeof HistoryModeRoute
  '/space/$threadId': typeof SpaceThreadIdRoute
  '/thread/$threadId': typeof ThreadThreadIdRoute
  '/announcements': typeof AnnouncementsIndexRoute
  '/$slug/thread/$threadId': typeof SlugThreadThreadIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/announcements': typeof AnnouncementsRouteWithChildren
  '/api-docs': typeof ApiDocsRoute
  '/app-auth': typeof AppAuthRoute
  '/archive': typeof ArchiveRoute
  '/board': typeof BoardRoute
  '/jukebox': typeof JukeboxRoute
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRoute
  '/announcements/$announcementId': typeof AnnouncementsAnnouncementIdRoute
  '/history/$mode': typeof HistoryModeRoute
  '/space/$threadId': typeof SpaceThreadIdRoute
  '/thread/$threadId': typeof ThreadThreadIdRoute
  '/announcements/': typeof AnnouncementsIndexRoute
  '/$slug/thread/$threadId': typeof SlugThreadThreadIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/announcements'
    | '/api-docs'
    | '/app-auth'
    | '/archive'
    | '/board'
    | '/jukebox'
    | '/search'
    | '/settings'
    | '/announcements/$announcementId'
    | '/history/$mode'
    | '/space/$threadId'
    | '/thread/$threadId'
    | '/announcements/'
    | '/$slug/thread/$threadId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/api-docs'
    | '/app-auth'
    | '/archive'
    | '/board'
    | '/jukebox'
    | '/search'
    | '/settings'
    | '/announcements/$announcementId'
    | '/history/$mode'
    | '/space/$threadId'
    | '/thread/$threadId'
    | '/announcements'
    | '/$slug/thread/$threadId'
  id:
    | '__root__'
    | '/'
    | '/announcements'
    | '/api-docs'
    | '/app-auth'
    | '/archive'
    | '/board'
    | '/jukebox'
    | '/search'
    | '/settings'
    | '/announcements/$announcementId'
    | '/history/$mode'
    | '/space/$threadId'
    | '/thread/$threadId'
    | '/announcements/'
    | '/$slug/thread/$threadId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AnnouncementsRoute: typeof AnnouncementsRouteWithChildren
  ApiDocsRoute: typeof ApiDocsRoute
  AppAuthRoute: typeof AppAuthRoute
  ArchiveRoute: typeof ArchiveRoute
  BoardRoute: typeof BoardRoute
  JukeboxRoute: typeof JukeboxRoute
  SearchRoute: typeof SearchRoute
  SettingsRoute: typeof SettingsRoute
  HistoryModeRoute: typeof HistoryModeRoute
  SpaceThreadIdRoute: typeof SpaceThreadIdRoute
  ThreadThreadIdRoute: typeof ThreadThreadIdRoute
  SlugThreadThreadIdRoute: typeof SlugThreadThreadIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/announcements': {
      id: '/announcements'
      path: '/announcements'
      fullPath: '/announcements'
      preLoaderRoute: typeof AnnouncementsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api-docs': {
      id: '/api-docs'
      path: '/api-docs'
      fullPath: '/api-docs'
      preLoaderRoute: typeof ApiDocsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app-auth': {
      id: '/app-auth'
      path: '/app-auth'
      fullPath: '/app-auth'
      preLoaderRoute: typeof AppAuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/archive': {
      id: '/archive'
      path: '/archive'
      fullPath: '/archive'
      preLoaderRoute: typeof ArchiveRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/board': {
      id: '/board'
      path: '/board'
      fullPath: '/board'
      preLoaderRoute: typeof BoardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/jukebox': {
      id: '/jukebox'
      path: '/jukebox'
      fullPath: '/jukebox'
      preLoaderRoute: typeof JukeboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/announcements/': {
      id: '/announcements/'
      path: '/'
      fullPath: '/announcements/'
      preLoaderRoute: typeof AnnouncementsIndexRouteImport
      parentRoute: typeof AnnouncementsRoute
    }
    '/announcements/$announcementId': {
      id: '/announcements/$announcementId'
      path: '/$announcementId'
      fullPath: '/announcements/$announcementId'
      preLoaderRoute: typeof AnnouncementsAnnouncementIdRouteImport
      parentRoute: typeof AnnouncementsRoute
    }
    '/history/$mode': {
      id: '/history/$mode'
      path: '/history/$mode'
      fullPath: '/history/$mode'
      preLoaderRoute: typeof HistoryModeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/space/$threadId': {
      id: '/space/$threadId'
      path: '/space/$threadId'
      fullPath: '/space/$threadId'
      preLoaderRoute: typeof SpaceThreadIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/thread/$threadId': {
      id: '/thread/$threadId'
      path: '/thread/$threadId'
      fullPath: '/thread/$threadId'
      preLoaderRoute: typeof ThreadThreadIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$slug/thread/$threadId': {
      id: '/$slug/thread/$threadId'
      path: '/$slug/thread/$threadId'
      fullPath: '/$slug/thread/$threadId'
      preLoaderRoute: typeof SlugThreadThreadIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AnnouncementsRouteChildren {
  AnnouncementsAnnouncementIdRoute: typeof AnnouncementsAnnouncementIdRoute
  AnnouncementsIndexRoute: typeof AnnouncementsIndexRoute
}

const AnnouncementsRouteChildren: AnnouncementsRouteChildren = {
  AnnouncementsAnnouncementIdRoute: AnnouncementsAnnouncementIdRoute,
  AnnouncementsIndexRoute: AnnouncementsIndexRoute,
}

const AnnouncementsRouteWithChildren = AnnouncementsRoute._addFileChildren(
  AnnouncementsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AnnouncementsRoute: AnnouncementsRouteWithChildren,
  ApiDocsRoute: ApiDocsRoute,
  AppAuthRoute: AppAuthRoute,
  ArchiveRoute: ArchiveRoute,
  BoardRoute: BoardRoute,
  JukeboxRoute: JukeboxRoute,
  SearchRoute: SearchRoute,
  SettingsRoute: SettingsRoute,
  HistoryModeRoute: HistoryModeRoute,
  SpaceThreadIdRoute: SpaceThreadIdRoute,
  ThreadThreadIdRoute: ThreadThreadIdRoute,
  SlugThreadThreadIdRoute: SlugThreadThreadIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
